var _style, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElement2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11 11",
    style: {
      enableBackground: "new 0 0 11 11"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#858589;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:#FA9A63;}\n\t.st5{fill:#FADC63;}\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:url(#);stroke:#000000;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 0.4,
    y1: 10.6,
    x2: 10.6,
    y2: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement2);
export default __webpack_public_path__ + "static/media/Element2.ba4753d52981ff02d1d3f8f1ecc0f587.svg";
export { ForwardRef as ReactComponent };